import type { TemplateTab } from '../types/mapping-editor.types';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';
import { TemplateRow } from '../components/table/row/template-row.types';

export type TemplateByIdResponse = {
  documentName: null | string;
  equityPlan: { id: string; name: string } | null;
  fileLink: string;
  tabs?: TemplateTab[];
} & TemplateRow;

export const useTemplateById = (templateId: null | string) => {
  const { data, isPending, isError } = useAppQuery<TemplateByIdResponse>({
    queryKey: [QueryKey.GET_TEMPLATE_BY_ID, templateId],
    queryFn: () =>
      ApiService.get<TemplateByIdResponse>({
        endpoint: BackendRoute.TEMPLATES,
        routePath: [templateId!],
      }),
    enabled: !!templateId,
  });

  return {
    template: data ?? null,
    isPending,
    isError,
  };
};
